<template>

  <div class="relative">
    <header class="bg-brand text-brandText py-32 text-center uppercase">
      <p class="font-monospace font-bold text-24 letter-spacing-large">{{ bonusWord }}</p>
    </header>

    <div class="wrap py-24">
      <div class="text-left pb-24">
          <div v-if="textShareText" class="mb-8" v-html="textShareText.body.replace('{{ minutes }}', $options.filters.timeElapsed(secondsElapsed))"></div>
        <div v-else class="mb-8">
            <p>
                Proficiat. U hebt de puzzel opgelost in {{ secondsElapsed | timeElapsed }} minuten!
            </p>

            <p>
                Laat het weten aan uw vrienden.
            </p>
        </div>

        <div>
            <a :href="`https://www.facebook.com/sharer/sharer.php?u=${shareUrl}`" target="_blank">
                <span class="icn icon-facebook-square text-32"></span>
            </a>

            <a class="ml-12" :href="`https://twitter.com/share?url=${shareUrl}&text=${shareTextSocial}`" target="_blank">
                <span class="icn icon-twitter-square text-32"></span>
            </a>
        </div>
      </div>
    </div>

    <PuzzleArticleList/>

<!--    <div class="wrap py-32 ">-->
<!--        <a :href="newsUrl" class="c-button w-full text-center mx-auto block"  target="_blank">-->
<!--            {{ textArticles ? textArticles.button_text : 'Bekijk de DS nieuws startpagina' }}-->
<!--        </a>-->
<!--    </div>-->

<!--    <div class="wrap pt-32 pb-18 border-t border-black" v-if="ctaKarelsCrypto">-->
<!--        <div class="flex">-->
<!--            <div class="w-3/5">-->
<!--                <h2>Meer puzzels</h2>-->
<!--                <div v-html="ctaKarelsCrypto.body"></div>-->
<!--                <a href="https://www.standaard.be/puzzels" class="c-button c-button&#45;&#45;transparent w-auto flex px-0 py-18" target="_blank">-->
<!--                    <span class="c-button__text text-16">-->
<!--                        Speel nu-->
<!--                    </span>-->
<!--                    <span class="c-button__icon icon icon-arrow-small w-6 h-10"></span>-->
<!--                </a>-->
<!--            </div>-->

<!--            <figure class="w-2/5 flex flex-col justify-center items-end md:items-center">-->
<!--                <img width="70px" height="70px" class="" :src="`${baseUrl}/assets/images/karels_crypto.png`" alt="" />-->
<!--            </figure>-->
<!--        </div>-->
<!--    </div>-->

  </div>

</template>

<script>
  import { mapGetters, mapState } from 'vuex'
  import { find } from 'lodash'

  import PuzzleSolutionGrid from '@/components/puzzle/PuzzleSolutionGrid'
  import PuzzleArticleList from '@/components/puzzle/PuzzleArticleList'

  // const baseUrl = process.env.MIX_APP_URL
  const baseUrl = window.BASE_URL

  export default {
    name: 'PuzzleSolved',

    data ()  {
      return {
        baseUrl
      }
    },

    computed: {
      ...mapGetters([
        'puzzleTimerId'
      ]),

      ...mapState({
        puzzle: state => state.currentPuzzle,
        timers: state => state.timers,
        texts: state => state.texts
      }),

      bonusItem () {
        return find(this.puzzle.words, item => item.is_bonus)
      },

      bonusWord () {
        const item = this.bonusItem

        if (!item) {
          return null
        }

        return item.word
      },

      secondsElapsed () {
        return this.timers[this.puzzleTimerId]
      },

      ctaKarelsCrypto () {
        return this.$store.getters.textByRealm({ realm: 'cta_more_puzzles' })
      },

      textArticles () {
        return this.$store.getters.textByRealm({ realm: 'articles' })
      },

      textShareUrl () {
        return this.$store.getters.textByRealm({ realm: 'share_url' })
      },

      textShareText () {
        return this.$store.getters.textByRealm({ realm: 'share_text' })
      },

      textShareTextSocial () {
        return this.$store.getters.textByRealm({ realm: 'share_text_social' })
      },

      textNewsUrl () {
        return this.$store.getters.textByRealm({ realm: 'news_url' })
      },

      shareUrl () {
        return this.textShareUrl ? this.textShareUrl.title : 'https://www.standaard.be/woordslang'
      },

      shareTextSocial () {
        return this.textShareTextSocial ? this.textShareTextSocial.title : 'Ik heb de woordslang gevonden! Ook eens proberen?'
      },

      newsUrl () {
        return this.textNewsUrl ? this.textNewsUrl.title : 'https://www.standaard.be'
      }
    },

    components: {
      PuzzleSolutionGrid,
      PuzzleArticleList
    }
  }
</script>

<style>
    .c-hint-list__item--found {
        text-decoration: line-through;
    }
</style>
